import React, {useEffect, useState} from "react";
import Socials from "./socials";
import { Link, useNavigate } from "react-router-dom";
import Navigation from "./mobileNavigation";


export default function Header(){

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/');
    }
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
        window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    return(
        <header>
            <div className="navigation">
                {isMobile ? 
                     <Navigation />
                    : (
                        <ul>
                            <Link to={'/work'} className="link">
                                <li>Work</li>
                            </Link>

                            <Link to={'/aboutMe'} className="link">
                                <li>About</li>
                            </Link>

                            <Link to={'/contactMe'} className="link">
                                <li>Contact</li>
                            </Link>
                        </ul>
                    )}
                </div>
                
                <div className="name" onClick={handleClick}>
                    Manpreet's Portfolio

                
            </div>
            
            <Socials />
        </header>
    )

}